import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'

export default class FormAccountController extends Controller {
  declare firstNameTarget: HTMLInputElement
  declare lastNameTarget: HTMLInputElement
  declare emailTarget: HTMLInputElement
  declare hasPasswordTarget: boolean
  declare passwordTarget: HTMLInputElement
  declare hasPhoneTarget: boolean
  declare phoneTarget: HTMLInputElement
  static targets = ['firstName', 'lastName', 'email', 'password', 'phone']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.firstNameTarget.focus()
    this.setInitialValues()
  }

  setInitialValues() {
    if (!this.checkoutOutlet.signupData.account) return
    const { first_name, last_name, email, password, phone } =
      this.checkoutOutlet.signupData.account

    this.firstNameTarget.value = first_name
    this.lastNameTarget.value = last_name
    this.emailTarget.value = email

    if (this.hasPasswordTarget && password) {
      this.passwordTarget.value = password
    }

    if (this.hasPhoneTarget && phone) {
      this.phoneTarget.value = phone
      const formattedInput = this.element.querySelector<HTMLInputElement>('[name="phone_formatted"]')
      if (formattedInput && phone.length === 10) {
        formattedInput.value = this.formatPhoneNumber(phone)
      }
    }
  }

  private formatPhoneNumber(phone: string): string {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`
  }
}
